<section>
  <div class="header" [ngClass]="isMobile ? 'flex-column align-items-start' : 'flex-row align-items-center'">
    <b class="header-text color-primary">{{ title }}</b>

    <div class="d-flex flex-row align-items-center">
      <span class="pr-2">
        <tablesready-search-bar
          placeholder="Search invoice"
          btnColorClass="btn-light"
          [whiteIconColorEnabled]="false"
          (search)="search($event)"
        ></tablesready-search-bar>
      </span>

      <tablesready-collapse-toggle
        [active]="activeInvoicesBtnActive"
        (activeChange)="toggleDisplayInvoices('active-invoices-')"
      ></tablesready-collapse-toggle>
    </div>
  </div>
  <div class="scroll-table">
    <table class="table table-sm-bordered tr-table">
      <tbody>
      <tr class="d-none d-sm-table-row">
        <th>Invoice</th>
        <th>Date</th>
        <th>Status</th>
        <th>Total</th>
        <th></th>
      </tr>
      <tr
        *ngFor="let invoice of invoicesToDisplay  | slice: (pageIndex - 1) * pageSize : (pageIndex - 1) * pageSize + pageSize; index as index;"
        [id]="'active-invoices-' + index"
      >
        <td class="vertical-align-middle">
          #{{ invoice.number }}
        </td>
        <td class="vertical-align-middle" [innerText]="invoice.createdAt | trDateFormat:'MM/DD/YYYY h:mm a': timezone"></td>
        <td class="vertical-align-middle text-success" [innerText]="invoice.state | titlecase"></td>
        <td class="vertical-align-middle" [innerText]="'$' + invoice.total"></td>
        <td class="vertical-align-middle download-column">
          <button
            class="btn btn-md btn-outline-info"
            (click)="downloadInvoice(invoice.id)"
            (mousedown)="downloadIcon.color = iconColor.white; downloadIcon.generateStyles()"
            (mouseover)="downloadIcon.color = iconColor.white; downloadIcon.generateStyles()"
            (mouseleave)="downloadIcon.color = iconColor.blue; downloadIcon.generateStyles()"
          >
            <tr-icon
              #downloadIcon
              [icon]="icon.download"
              [color]="iconColor.blue"
            ></tr-icon>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <p *ngIf="invoices.length === 0" class="text-center my-2">You don't have any invoices.</p>

  <div class="pagination">
    <ngb-pagination
      [(page)]="pageIndex"
      [pageSize]="pageSize"
      [maxSize]="maxDisplayPages"
      [ellipses]="true"
      [collectionSize]="invoices.length"
    ></ngb-pagination>
  </div>
</section>
